// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-window-view',
    // #endregion
    // #region Properties
    props: {
        title: {
            type: String,
            default: ''
        },
        classContent: {
            type: String,
            required: false,
            default: 'content'
        },
        classWindow: {
            type: String,
            required: false,
            default: ''
        },
        showHeader: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    // #endregion
    // #region computed
    computed: {
        currentWindow() {
            return this.$utils.findVueComponent(this, ["g-modal-popup", "g-modal-slide"]);
        },
        hasFooterSlot() {
            return !!this.$slots['modal-footer'];
        },
        isClosable() {
            return this.currentWindow?.closable ?? false;
        }
    },
    // #endregion
    // #region Methods
    methods: {
        getComponent(componentName) {
            let component = null;
            let parent = this.$parent;
            while (parent && !component) {
                if (parent.$options.name === componentName) {
                    component = parent;
                }
                parent = parent.$parent;
            }
            return component;
        }
    }
    // #endregion
});
// #endregion
